import { useEffect } from "react";
import { SiteHeader } from "@/components/SiteHeader";
import { HeroRotator } from "@/components/HeroRotator";
import { ServicesBand } from "@/components/ServicesBand";
import { AboutAwards } from "@/components/AboutAwards";
import { OutcomesSection } from "@/components/OutcomesSection";
import { IMMSection } from "@/components/IMMSection";
import { RecipeGrid } from "@/components/RecipeGrid";
import { StatsBand } from "@/components/StatsBand";
import { FAQSection } from "@/components/FAQSection";
import { SiteFooter } from "@/components/SiteFooter";
import { ORG_SCHEMA_OBJ, FAQ_SCHEMA_OBJ } from "@/data/flatsomeBlocks";

export default function HomePage() {
  // Inject JSON-LD structured data (Organization + FAQPage)
  useEffect(() => {
    const scripts = [ORG_SCHEMA_OBJ, FAQ_SCHEMA_OBJ].map((obj) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.text = JSON.stringify(obj);
      document.head.appendChild(s);
      return s;
    });
    return () => scripts.forEach((s) => s.remove());
  }, []);

  return (
    <div data-testid="home-page" className="bg-white">
      <SiteHeader />
      <main>
        <HeroRotator />
        <ServicesBand />
        <AboutAwards />
        <OutcomesSection />
        <IMMSection />
        <RecipeGrid />
        <StatsBand />
        <FAQSection />
      </main>
      <SiteFooter />
    </div>
  );
}
